export const DEFAULT_BRAND_SETTINGS = {
  enabled: false,
  primary_color: '#111827',
  accent_color: '#6366f1',
  cover_image_url: null,
  logo_url: null,
  tagline: null,
  hero_style: 'classic',
  cta_label: null,
  show_logo_in_header: true,
};

export const mergeBrandSettings = (settings = {}) => ({
  ...DEFAULT_BRAND_SETTINGS,
  ...(settings && typeof settings === 'object' ? settings : {}),
});

export const isBrandActive = (brand) => Boolean(brand?.enabled);

export const getBrandFromVendor = (vendor) => {
  if (!vendor) return null;
  return vendor.brand && isBrandActive(vendor.brand) ? vendor.brand : null;
};

export const darkenColor = (hex, amount = 0.12) => {
  if (!hex || typeof hex !== 'string' || !/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    return '#111827';
  }
  const num = parseInt(hex.slice(1), 16);
  const r = Math.max(0, ((num >> 16) & 0xff) * (1 - amount));
  const g = Math.max(0, ((num >> 8) & 0xff) * (1 - amount));
  const b = Math.max(0, (num & 0xff) * (1 - amount));
  return `#${[r, g, b].map((v) => Math.round(v).toString(16).padStart(2, '0')).join('')}`;
};

export const buildBrandCssVars = (brand) => {
  if (!isBrandActive(brand)) return {};
  const primary = brand.primary_color || DEFAULT_BRAND_SETTINGS.primary_color;
  const accent = brand.accent_color || DEFAULT_BRAND_SETTINGS.accent_color;
  return {
    '--vendor-brand-primary': primary,
    '--vendor-brand-primary-hover': darkenColor(primary),
    '--vendor-brand-accent': accent,
  };
};

export const getBrandButtonStyle = (brand, variant = 'primary') => {
  if (!isBrandActive(brand)) return undefined;
  const primary = brand.primary_color || DEFAULT_BRAND_SETTINGS.primary_color;
  if (variant === 'outline') {
    return {
      borderColor: primary,
      color: primary,
      backgroundColor: 'transparent',
    };
  }
  return {
    backgroundColor: primary,
    borderColor: primary,
    color: '#ffffff',
  };
};

export const getBrandCtaLabel = (brand, fallback = 'View Services') =>
  (brand?.cta_label && brand.cta_label.trim()) || fallback;

export const filterBrandAssetsFromGallery = (images, brand) => {
  if (!Array.isArray(images)) return [];
  const exclude = new Set(
    [brand?.logo_url, brand?.cover_image_url].filter(Boolean)
  );
  return images.filter((url) => url && !exclude.has(url));
};

export const PRESET_COLORS = [
  { name: 'Midnight', primary: '#111827', accent: '#6366f1' },
  { name: 'Forest', primary: '#14532d', accent: '#22c55e' },
  { name: 'Wine', primary: '#7f1d1d', accent: '#f59e0b' },
  { name: 'Ocean', primary: '#0c4a6e', accent: '#38bdf8' },
  { name: 'Plum', primary: '#581c87', accent: '#e879f9' },
  { name: 'Slate', primary: '#334155', accent: '#94a3b8' },
];
